<div class="restores">
  @if (restores$ | async; as records) {
    <div class="filters">
      <app-date-picker
        id="date-picker"
        label="Restore Date"
        placeholder="DD/MM/YYYY"
        type="range"
        [formControl]="dateRange"
      ></app-date-picker>

      <button matButton="outlined" (click)="clearFilters()">
        <fa-icon [icon]="['fas', 'filter-circle-xmark']" size="lg"></fa-icon>
        Clear Filter
      </button>
    </div>

    <div class="table-container">
      <div class="header">
        <h2>Restores</h2>
      </div>

      <mat-card appearance="outlined" class="table-inner">
        <app-table
          #table
          [columns]="restoresColumns"
          [dataSource]="records"
          [totalCount]="allRestoresCount()"
          (pageChange)="handlePageEvent($event)"
        >
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let element">
              <app-status-label [status]="toStatus(element.status)"></app-status-label>
            </td>
          </ng-container>

          <ng-container matColumnDef="runtime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let element">
              <div>
                Finished:
                {{ element.endDate ? (element.endDate | date: 'dd.MM.yyyy, hh:mm') : 'N/A' }}
              </div>
              <small>
                Started:
                {{ element.startDate ? (element.startDate | date: 'dd.MM.yyyy, hh:mm') : 'N/A' }}
              </small>
            </td>
          </ng-container>

          <ng-container matColumnDef="buttons">
            <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
            <td mat-cell *matCellDef="let element">
              <div class="buttons">
                <button
                  matRipple
                  class="button"
                  matTooltip="Restore Details"
                  [matTooltipShowDelay]="500"
                  matTooltipPosition="above"
                  [routerLink]="['/restores', element.id, 'website', website().id]"
                >
                  <fa-icon [icon]="['fas', 'arrow-right']" size="lg"></fa-icon>
                </button>
              </div>
            </td>
          </ng-container>
        </app-table>
      </mat-card>
    </div>
  }
</div>
